import {RecorderService} from "./recorder.service";

export const RecorderInjectables: Array<any> = [
  {
    provide: RecorderService,
    useClass: RecorderService,
  },
];
